import axios from "axios";

export default {
  async create(formData) {
    const files = new FormData();
    for (let i=0; i<formData.files.length; i+=1) {
      files.append("files", formData.files[i]);
    }
    files.append("data", JSON.stringify(formData.formData));

    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.post(`/promotions`, files, config);
  },
  async findOne({ id }) {
    return axios.get(`/promotions/${id}`);
  },
  async findAll() {
    return axios.get('/promotions');
  },
  async delete({ id }) {
    return axios.delete(`/promotions/${id}`);
  },
  async update(formData) {
    const files = new FormData();
    for (let i=0; i<formData.files.length; i+=1) {
      files.append("files", formData.files[i]);
    }
    files.append("data", JSON.stringify(formData.formData));

    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.put(`/promotions/${formData.id}`, files, config);
  }
};
